import React, { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import Logo from './Logo';
import { useAuth } from '../auth/AuthContext';
import { paths } from '../routes/paths';
import AccountMenu from './AccountMenu';
import ThemeToggle from './ThemeToggle';
import NotificationBell from './NotificationBell';
import '../styles/site.css';

// Site header for the attendee-facing pages: logo, nav, a quick search that sends people to Discover
// (/?q=...), and the account. Panel users also get a link to their panel.
function Header() {
  const { user, isLoggedIn, signOut } = useAuth();
  const navigate = useNavigate();
  const [q, setQ] = useState('');

  const search = (e) => {
    e.preventDefault();
    navigate(q.trim() ? `${paths.home}?q=${encodeURIComponent(q.trim())}` : paths.home);
  };

  return (
    <header className="site-header">
      <div className="site-bar">
        <Link to={paths.home} className="site-logo" aria-label="Events Ignite home">
          <Logo alt="" />
        </Link>

        <nav className="site-nav" aria-label="Main">
          <NavLink to={paths.home} end>Discover</NavLink>
          <NavLink to={paths.myTickets}>My tickets</NavLink>
          {isLoggedIn && <NavLink to={paths.orders}>Orders</NavLink>}
        </nav>

        <form className="site-search" onSubmit={search} role="search">
          <input type="search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search events, artists, venues" aria-label="Search events" />
        </form>

        <div className="site-account">
          <ThemeToggle />
          {isLoggedIn ? (
            <>
              <NotificationBell />
              <AccountMenu user={user} onLogout={signOut} />
            </>
          ) : (
            <>
              <Link to={paths.login} className="site-link">Log in</Link>
              <Link to={paths.register} className="site-cta">Sign up</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
